// extracted by mini-css-extract-plugin
module.exports = {"container":"_2KdASuk6TIUuotb8XMsm3y"};